import { useEffect, useRef } from 'react';
import Script from 'next/script';
import { useCartId, useCartUpdateAttributes, useCart } from '@backpackjs/storefront';

const fueledScriptUrl = process.env.NEXT_PUBLIC_FUELED_SCRIPT_URL || 'https://mb-cdn.fueled.io/fueled/53616c7465645f5fcaa90562d5c47b67f0bf839814184b25bbd6cc8495722e955af76bdd9f94440c3b77ce32952c84ab40e260d4301faab4d3ef98b522323d4c/packdigital/js';


export function FueledClientScript() {
  const cartId = useCartId();
  const cart = useCart();
  const { cartUpdateAttributes } = useCartUpdateAttributes();
  const cartRef = useRef(cart);
  const cartUpdateAttributesRef = useRef(cartUpdateAttributes);

  useEffect(() => {
    cartRef.current = cart;
  }, [cart]);

  useEffect(() => {
    cartUpdateAttributesRef.current = cartUpdateAttributes;
  }, [cartUpdateAttributes]);

  useEffect(() => {
    if (!cartId) return () => null;

    let isStale = false;

    const setCartToken = async () => {
      const fueled = window.fueled || {};

      const res = await fueled.setFrontendStorage(
        fueled.config.frontendStorageUrl,
        cartId.replace('gid://shopify/Cart/', '')
      );

      const {
        context: {
          anonymousId,
          ga4: { clientId = undefined, sessionId = undefined } = {},
          fb: { fbp = undefined, fbc = undefined } = {},
        },
      } = await res.json();

      if (isStale) return;

      const currentCart = cartRef.current;
      const existingAttributes = currentCart?.attributes || [];
      
      const attributesToUpdate = existingAttributes
        .filter(attr => attr.key !== 'fueled_context')
        .concat([
          {
            key: 'fueled_context',
            value: JSON.stringify({
              anonymousId,
              ga4: { clientId, sessionId },
              fb: { fbp, fbc },
            }),
          },
        ]);

      await cartUpdateAttributesRef.current({
        attributes: attributesToUpdate,
      });
    };

    if (window.fueled) {
      setCartToken();
    } else {
      window.addEventListener('fueled-ready', setCartToken);
    }

    return () => {
      isStale = true;
      window.removeEventListener('fueled-ready', setCartToken);
    };
  }, [cartId]);

  return <Script type="text/javascript" src={fueledScriptUrl} />;
}